var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[(_vm.treeData.length)?_c('v-tree',{ref:"tree",attrs:{"data":_vm.treeData,"radio":true,"selectAlone":true,"draggable":false,"halfcheck":true,"tpl":_vm.tpl},on:{"node-check":_vm.nodeChecked}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }